import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listWorkflowTagPool } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'
import {
  ListWorkflowTagPoolRequestSchema,
  type ListWorkflowTagPoolResponse,
} from '@ebalance/proto/bffuser/v1/workflow_case_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 組織全体のタグプール (spec AC-TAG-005) 取得 hook。
 *
 * 3 箇所のタグ入力欄 (新規ワークフロー作成ダイアログ / 業務ワークフロー詳細の
 * タグ編集 / 雛形編集画面のデフォルトタグ入力) で共通のサジェスト元・
 * 20 個上限の事前チェック元として使う (design
 * tag-pool-limit-and-suggest, AC-TAG-006/AC-TAG-008)。cache key
 * (`['listWorkflowTagPool']` 相当) は 3 画面で共有される。
 */
export function useListWorkflowTagPool(): UseQueryResult<
  ListWorkflowTagPoolResponse,
  ConnectError
> {
  return useQuery(
    listWorkflowTagPool,
    create(ListWorkflowTagPoolRequestSchema, {}),
  )
}
